module.exports = "/_next/static/images/9f8bd19325ca5b208342b8defc0edef6-youtube.svg.webp";